import { Box, Dialog, DialogContent, Stack, Tab } from "@mui/material";
import { MprcContainer, MprcDialogTitleClose } from "components";
import { MprcChipTabs } from "components/MprcChipTabs";
import { DirectMessageListResponse, SelectMessageDirect } from "generated/CoreApi_v1";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ListDirectMessage } from "views/foundation/directMessage/ListDirectMessage";
import { INewDirectMessage, NewDirectMessage } from "views/foundation/directMessage/NewDirectMessage";

interface IProps {
    onClose: (success: boolean) => void;
}

type TabNames = "received" | "sent" | "newMessage";

/////////////////////////////////////////////////////////////////////////////////

export const DirectMessageDialog: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const { onClose } = props;
    const [selectedTab, setSelectedTab] = useState<TabNames>("received");
    const [newMessage, setNewMessage] = useState<INewDirectMessage | null>();

    ///
    const forward = (message: DirectMessageListResponse) => {
        setSelectedTab("newMessage");
        setNewMessage({ action: "forward", message });
    };

    ///
    const reply = (message: DirectMessageListResponse) => {
        setSelectedTab("newMessage");
        setNewMessage({ action: "reply", message });
    };

    ///
    useEffect(() => {
        if (selectedTab != "newMessage") {
            setNewMessage(null);
        }
    }, [selectedTab]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <div>
            <Dialog open fullWidth maxWidth="sm" onClose={() => onClose(false)}
                sx={{ "& .MuiPaper-root": { minHeight: "640px" } }}
            >
                <MprcDialogTitleClose
                    title={t("DirectMessage.Title")}
                    onClose={() => onClose(false)}
                    shrinkPadding
                />
                <DialogContent sx={{ display: "flex" }}>
                    <Box width="100%">
                        <Stack direction="column" width="100%" height="100%">
                            <MprcContainer>
                                <MprcChipTabs
                                    value={selectedTab}
                                    onChange={(e, value) => setSelectedTab(value)}
                                >
                                    <Tab
                                        label={t("DirectMessage.Tab.RecivedText")}
                                        value={"received"}
                                    />
                                    <Tab
                                        label={t("DirectMessage.Tab.SentText")}
                                        value={"sent"}
                                    />
                                    <Tab
                                        label={t("DirectMessage.Tab.NewMessageText")}
                                        value={"newMessage"}
                                    />
                                </MprcChipTabs>
                            </MprcContainer>
                            <Box id="messages" flexGrow={1} sx={{ overflowX: "hidden", overflowY: "auto" }}>
                                {
                                    selectedTab == "newMessage"
                                        ? <NewDirectMessage newMessage={newMessage} />
                                        : <ListDirectMessage
                                            messageListType={selectedTab == "sent" ? SelectMessageDirect.Sent : SelectMessageDirect.Received}
                                            onReply={reply}
                                            onForward={forward}
                                        />
                                }
                            </Box>
                        </Stack>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
};
